import ImagePopup from '@/components/popup/imagePopup.vue';

let popup: any = null;

export interface ImagePopupOptions {
    src: string;
    imageClass?: string
}

/**
 * 获取一个popup
 */
export function getImagePopup(options: ImagePopupOptions) {
    if (popup) {
        return popup;
    }

    popup = new ImagePopup({
        el: document.createElement('div'),
        propsData: {
            src: options.src,
            imageClass: options.imageClass
        },
    });

    document.body.appendChild(popup.$el);
    return popup;
}

export function showImagePopup(options: ImagePopupOptions): Cancellable {
    const popup = getImagePopup(options);
    popup.src = options.src;
    popup.imageClass = options.imageClass;
    popup.value = true;

    return () => {
        popup.value = false;
    };
}
